import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { versionPlugins } from '../index';
export const useVersionPlugins = (callback) => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(versionPlugins, {
        onSuccess: () => {
            queryClient.invalidateQueries('SetActualPluginVersionOnInstances');
            setAction({
                type: 'success',
                message: 'success',
            });
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
